import { Api } from './axios-config';

export interface ICalendar {
  id: number;
  month: number;
  monthString: string;
  monthDay: number;
  monthDayString: string;
  weekDay: string;
}

const getDays = async (): Promise<ICalendar[]> => {
  try {
    const { data } = await Api.get<ICalendar[]>(
      '/calendar'
    );

    return data;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};

export const calendarService = {
  getDays
};